


















import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'

@Component({
  name: 'partiallyReservedModal'
})
export default class extends Vue {
  @Prop() amount!: number
  @Prop() reserveId!: string

  formattedAmount = ''

  @Watch('amount')
  onAmountChange() {
    this.formattedAmount = this.$n(this.amount, 'currency')
  }
}
